import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profil-acheteur-editor',
  templateUrl: './profil-acheteur-editor.component.html',
  styleUrls: ['./profil-acheteur-editor.component.css']
})
export class ProfilAcheteurEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
